export interface ISetSession {
  type: SessionActionTypes.SET_SESSION;
  signUp?: boolean;
}

export interface IReadSession {
  type: SessionActionTypes.READ_SESSION;
}
export interface IReadSessionSuccess {
  type: SessionActionTypes.READ_SESSION_SUCCESS;
  tokenExpiration: number;
  currentTenant: string;
  scopesDetected: string[];
  tenant?: string;
  role?: string;
}

export interface IReadSessionFailed {
  type: SessionActionTypes.READ_SESSION_FAILED;
  error: string;
}

export interface IDeleteSession {
  type: SessionActionTypes.DELETE_SESSION;
}

export type SessionAction =
  | ISetSession
  | IDeleteSession
  | IReadSession
  | IReadSessionSuccess
  | IReadSessionFailed;

export interface sessionTokenData {
  tokenExpiration: number;
  currentTenant: string;
  allowedScopes?: string[];
}

export interface SessionState {
  tokenData?: sessionTokenData;
  loading: boolean;
  tenants: string[];
  error: string;
  tenant?: string;
  role?: string;
  sessionRead?: boolean;
}

export enum SessionActionTypes {
  DELETE_SESSION = "session/delete",
  SET_SESSION = "session/set",
  READ_SESSION = "session/read",
  READ_SESSION_SUCCESS = "session/read_success",
  READ_SESSION_FAILED = "session/read_failed",
  LOAD_DATA = "session/load_data",
}
